import React, { useEffect, useState } from 'react';

// Material UI
import { 
    Button,
    Fab, 
    IconButton,
    TextField,
    Tooltip
} from '@material-ui/core';

// Material UI Icons
import AddIcon from '@material-ui/icons/Add';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

// COMPONENTS
import CustomModal from '../components/CustomModal';

// SERVICES
import { firebase } from '../firebase/firebaseConfig';

// AG-GRID
import { AgGridReact, AgGridColumn } from 'ag-grid-react';
// import 'ag-grid-community/dist/styles/ag-grid.css';
// import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

// UTILS
import { filterParams } from '../Utills';

// OTHERS
import { nanoid } from 'nanoid';
import moment from 'moment';


export const ManageAccountsPage = () => {

    // ag grid
    // eslint-disable-next-line no-unused-vars
    const [gridApi, setGridApi] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [rowData, setRowData] = useState(null);

    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }

    const [open, setOpen] = useState(false);

    const initUser = {
        email: '',
        givenNames: '',
        lastName: '',
        // phoneNumber: ''
    };

    const [user, setUser] = useState(initUser);

    const handleClose = () => {
        setOpen(false);
        setUser(initUser);
    };
    
    // Category list
    const getCategory = async () => {
        try {
            const result = await fetch(`${process.env.REACT_APP_API_URL}/user/list`);
            const { data } = await result.json();
            setRowData(data);
        } catch (error) {
            console.log(error);
        }
    }
    
    // Create and invite user
    const inviteUser = async (e) => {
        e.preventDefault();
        try {
            const config = {
                method: user._id ? 'PUT':'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(user)
            };
            const url = user._id ? `${process.env.REACT_APP_API_URL}/user/update-one` : `${process.env.REACT_APP_API_URL}/user/create-user`;
            const result = await fetch(url, config);
            // console.log(await result.json());
            if(user._id){
                getCategory();
                handleClose();
                return;
            }

            if (result.ok) {
                const userCredential = await firebase.auth().createUserWithEmailAndPassword(email, nanoid());
                if (userCredential.additionalUserInfo.isNewUser) {
                    
                    await firebase
                        .auth()
                        .sendPasswordResetEmail(email);
                
                }
            }
        } catch (error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log(errorCode,errorMessage);
            // getCategory();
            // handleClose();
        }        
    };

    // get user
    const getUser = async (id) => {
        try {
            const result = await fetch(`${process.env.REACT_APP_API_URL}/user/get-one/${id}`);
            const resultJSON = await result.json();
            setUser(resultJSON.data);
        } catch (error) {
            console.log(error);
        }
    };
    
    const removeUser = async (id) => {
        try {
            const config = {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            };
            const result = await fetch(`${process.env.REACT_APP_API_URL}/user/delete-one/${id}`, config);
            await result.json();
            getCategory();
            handleClose();
        } catch (error) {
            console.log(error);
        }
    }
    const {
        email,
        givenNames,
        lastName,
    } = user;
    useEffect(() => {
        getCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Table action buttons
    const ActionCellRenderer = (props) => {
        return <>
            <Tooltip title="Editar">
                <IconButton size="small">
                    <EditIcon 
                        // style={{ color: 'blue', marginRight: '0.3em' }}
                        onClick={()=> {
                            getUser(props.data._id);
                            setOpen(true);
                        }}
                    />
                </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar">    
                <IconButton size="small">
                    <DeleteIcon 
                        style={{ color: 'red' }}
                        onClick={()=> removeUser(props.data._id)}
                    />
                </IconButton>
            </Tooltip>
        </>
    }    
    
    return (
        <>
                <CustomModal
                    open={open}
                    handleClose={handleClose}
                    title="Invitar usuario"
                >
                    <div style={{ width: '400px' }}>
                        <form onSubmit={inviteUser}>
                            <TextField 
                                id="givenNames" 
                                label="Nombre(s)" 
                                name="givenNames" 
                                placeholder="Given Names"
                                fullWidth
                                value={givenNames}
                                onChange={e => setUser({
                                    ...user,
                                    givenNames: e.target.value
                                })}
                            />
                            <TextField 
                                id="lastName" 
                                label="Apellidos" 
                                name="lastName" 
                                placeholder="Last Name"
                                fullWidth
                                value={lastName}
                                onChange={e => setUser({
                                    ...user,
                                    lastName: e.target.value
                                })}
                            />
                            <TextField 
                                id="email" 
                                label="Correo" 
                                name="email" 
                                placeholder="Email"
                                type="email"
                                fullWidth
                                value={email}
                                onChange={e => setUser({
                                    ...user,
                                    email: e.target.value
                                })}
                            />
                            <Button 
                                style={{ width: '100%', marginTop: '1em', }}
                                variant="contained"
                                color="primary"
                                type="submit"
                                startIcon={<AddCircleOutlineIcon/>}
                                disabled={!email}
                            >
                                Agregar
                            </Button>
                        </form>
                    </div>
                </CustomModal>
                <div style={{ width: '100%', height: '100%' }}>
      <div
        id="myGrid"
        style={{
          height: '500px',
          width: '100%',
        }}
        className="ag-theme-alpine"
      >
        <AgGridReact
          defaultColDef={{
            editable: true,
            sortable: true,
            flex: 1,
            minWidth: 100,
            menuTabs:['filterMenuTab'],
            suppressMenu: true,
            // suppressMenuHide: true,
            unSortIcon: false,
            floatingFilter: true,
            filter: true,
            resizable: true,
          }}
          pagination={true}
          paginationPageSize={12}
          frameworkComponents={{actionCellRenderer:ActionCellRenderer}}
          onGridReady={onGridReady}
          rowData={rowData}
          
        >
          <AgGridColumn 
            headerName="Nombre(s)"
            field="givenNames" 
          />
          <AgGridColumn 
            headerName="Apellidos"
            field="lastName" 
          />
          <AgGridColumn 
            headerName="Correo"
            field="email" 
          />
          <AgGridColumn 
            headerName="Rol"
            field="role" 
          />
          <AgGridColumn 
            headerName="Fecha de creación"
            field="createdAt" 
            cellRenderer={data => (data.value ? moment(data.value).format("DD-MM-YYYY") : null)}
            filter= 'agDateColumnFilter'
            filterParams={filterParams}
          />
          <AgGridColumn
            headerName="Fecha de modificación"
            field="updatedAt"
            cellRenderer={data => (data.value ? moment(data.value).format("DD-MM-YYYY") : null)}
            filter= 'agDateColumnFilter'
            filterParams={filterParams}
          />
          <AgGridColumn
            headerName="Acciones"
            cellRenderer="actionCellRenderer"
            filter={false}
          />
        </AgGridReact>
      </div>
    </div>
                <Fab 
                    onClick={() => setOpen(true)}
                    style={{ margin: '0px', top: 'auto',right: '1em',bottom: '1em',left: 'auto',position: 'fixed', }} color="primary" aria-label="add"
                >
                    <AddIcon />
                </Fab>
        </>
    )
}
